export default __webpack_public_path__ + "static/media/reload.b2e4f7bf.svg";